import { render, staticRenderFns } from "./synchronization-admin.view.vue?vue&type=template&id=f5982616&scoped=true&"
import script from "./synchronization-admin.view.ts?vue&type=script&lang=ts&"
export * from "./synchronization-admin.view.ts?vue&type=script&lang=ts&"
import style0 from "./synchronization-admin.view.scss?vue&type=style&index=0&id=f5982616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5982616",
  null
  
)

export default component.exports